import { QUERY as l } from "../../constants/query.js";
import { useConfigContext as k } from "../config/ConfigContext.js";
import D from "../../hooks/generic/usePersistQuery.js";
import G from "../../hooks/graphql/useCheckInviter.js";
import Q from "../../hooks/graphql/useGetBelievedInviter.js";
import _ from "../../hooks/graphql/useSendBelieveInviter.js";
import { isFullInviteCode as g } from "../../util/adeptus/index.js";
import { createStrictContext as q } from "../../util/context/createStrictContext.js";
import { removeQuery as A, queryGetOne as E } from "../../util/query/index.js";
import { useRouter as M } from "next/router";
import * as t from "ramda";
import { useMemo as y, useState as v, useCallback as B, useEffect as N } from "react";
import { jsx as T } from "react/jsx-runtime";
const [V, ee] = q("Adeptus"), te = (P) => {
  var C;
  const {
    children: x
  } = P, e = M(), {
    config: s
  } = k(), c = y(() => {
    var i;
    return ((i = s == null ? void 0 : s.adeptus) == null ? void 0 : i.autoBelievePaths) || [];
  }, [(C = s == null ? void 0 : s.adeptus) == null ? void 0 : C.autoBelievePaths]), {
    fetch: d
  } = Q(), {
    fetch: p
  } = G(), {
    mutate: f
  } = _(), [r, O] = v(""), [n, R] = v(null), [S, a] = v(null);
  D([l.INVITE_CODE]);
  const I = y(() => t.isNil(c) ? [] : t.map(A, c), [c]), o = B(async () => {
    if (e && t.includes(A(e.asPath), I)) {
      const {
        query: i
      } = e, m = E(i, l.CAMPAIGN_ID), u = E(i, l.INVITE_CODE);
      if (!t.isEmpty(r) && !t.isEmpty(m) && g(u)) {
        const b = await d({
          id: m,
          address: r
        });
        if (t.pathOr("", ["invitation", "code"], b) !== u) {
          const h = await p(u);
          t.isNil(h) || await f({
            id: m,
            code: u,
            address: r
          }) && a(h);
        }
      }
    }
  }, [f, p, d, e, I, r]), w = B(() => {
    n && a(n);
  }, [n]);
  return N(() => {
    o();
  }, [o]), N(() => {
    if (t.isNotNil(e))
      return e.events.on("routeChangeComplete", o), () => {
        e.events.off("routeChangeComplete", o);
      };
  }, [o, e]), /* @__PURE__ */ T(V, {
    value: {
      inviter: n,
      successInviter: S,
      handleOnInviteSuccess: w,
      setInviter: R,
      setSuccessInviter: a,
      setWalletAddress: O
    },
    children: x
  });
};
export {
  te as AdeptusProvider,
  ee as useAdeptusContext
};
//# sourceMappingURL=AdeptusContext.js.map
